import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    FormEmailInputComponent
} from "../../../common/forms/form-email-input/form-email-input.component";
import {
    FormLabelComponent
} from "../../../common/forms/form-label/form-label.component";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    FormsModule, ReactiveFormsModule,
    Validators
} from "@angular/forms";
import {
    AppAlertService,
    ParametersService, SettingsNotificationsService,
    SettingsService,
    SubtitlesService
} from "../../../core";
import * as _ from "lodash";

@Component({
  selector: 'notification-email',
  standalone: true,
    imports: [
        FormActionButtonsComponent,
        FormButtonComponent,
        FormEmailInputComponent,
        FormLabelComponent,
        FormsModule,
        ReactiveFormsModule
    ],
  templateUrl: './notification-email.component.html',
  styleUrl: './notification-email.component.scss'
})
export class NotificationEmailComponent implements OnInit {
    @Output() close = new EventEmitter();
    notificationEmailForm: FormGroup;

    constructor(
        private appAlert: AppAlertService,
        private fb: FormBuilder,
        private parameters: ParametersService,
        private settings: SettingsService,
        private settingsNotifications: SettingsNotificationsService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit(): void {
        this.notificationEmailForm = this.fb.group({
            notificationEmail: ['', [Validators.required, Validators.email]]
        });
        this.notificationEmailForm.patchValue({notificationEmail: this.settings.selectedModule.email });
    }

    get notificationEmailControl() {
        return this.notificationEmailForm.get('notificationEmail') as FormControl;
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    closeForm(): void {
        this.close.emit();
    }

    changeNotificationEmail(): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }
        this.settingsNotifications.newNotificationEmail = this.notificationEmailControl.value;
        this.settingsNotifications.changeNotificationEmail();
        this.closeForm();
    }
}
